import { render, staticRenderFns } from "./Counting.vue?vue&type=template&id=197114a6&scoped=true"
import script from "./Counting.vue?vue&type=script&lang=js"
export * from "./Counting.vue?vue&type=script&lang=js"
import style0 from "./Counting.vue?vue&type=style&index=0&id=197114a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197114a6",
  null
  
)

export default component.exports